import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-304"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.315 2.086a3.146 3.146 0 0 0-.396.04 4.675 4.675 0 0 0-7.838 0 3.146 3.146 0 0 0-.396-.04 3.184 3.184 0 1 0 1.243 6.116 4.61 4.61 0 0 0 6.144 0 3.185 3.185 0 1 0 1.243-6.116zm0 5.369a2.17 2.17 0 0 1-.852-.173 1 1 0 0 0-1.05.167 3.61 3.61 0 0 1-4.827 0 1 1 0 0 0-1.049-.167 2.185 2.185 0 1 1-.852-4.196 1.237 1.237 0 0 1 .17.018l.101.014a1 1 0 0 0 .962-.444 3.675 3.675 0 0 1 6.164 0 1 1 0 0 0 .962.444l.102-.014a1.237 1.237 0 0 1 .17-.018 2.184 2.184 0 1 1 0 4.369zM2.998 12.5a1 1 0 1 0 2 0 6.604 6.604 0 0 0-1-2 6.604 6.604 0 0 0-1 2zm5.676-.86c-.058 0-.096-.051-.07-.095l.858-1.462c.026-.044-.012-.096-.07-.096h-1.71a.167.167 0 0 0-.145.078l-1.514 2.681c-.045.08.024.172.128.172H7.69c.054 0 .091.045.074.088l-.8 1.976c-.03.07.078.12.134.064l3.227-3.297c.042-.043.006-.109-.06-.109z",
  style: {"fill-rule":"evenodd"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12.5",
  cy: "12",
  r: "1"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }